import { u_ } from "@pressmedia/webappbase";
import _frameProps from "./_frameProps";

// **** for useFrame: true ****
export default {
	_frameProps,
	
	/**
	 * iframeのvuwを追加する関数
	 */
	_addFrame() {
		const props = { ...this._frameProps };
		
		// スタイルシートの設定
		if( u_.isString(this.config.styleSheet) && this.config.styleSheet ) {
			// configに指定されている場合はそれを使用
			props.styleSheet = this.config.styleSheet.replace(
				/\{root\}/g,
				this.app._relativePath
			);
		}
		
		return new Promise((resolve, reject) => {
			this.add("frame", props, function() {
				this.getReady().then(resolve, reject);
			});
		});
	}
};
